export default "__VITE_ASSET__mTtKhWJj__"